<template>
	<div ref="container" style="height:100%;position:relative;overflow:hidden;"></div>
</template>

<script>
import ScrollerWidget from '@/widgets/ScrollerWidget';

let msgIdCounter = 0;

const USERNAMES = ['StreamerFan99', 'TechWizard', 'CosmicViewer', 'NightOwl42', 'PixelKnight', 'GamerPro77', 'CoolCat88', 'StreamLurker', 'HappyDonor', 'LoyalViewer'];

export default {
	name: 'ScrollerWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
		realData: { type: Boolean, default: false },
	},
	data() {
		return {
			services: [],
		};
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
		realData() { this._destroyWidget(); this._initWidget(); },
	},
	mounted() {
		this._initWidget();
		if(!this.realData) {
			this.$api.get('channels')
				.then(channels => {
					const seen = new Set();
					this.services = channels.filter(c => {
						if(!c.service_icon_url || seen.has(c.service_id)) return false;
						seen.add(c.service_id);
						return true;
					});
					this._populateFakeAlerts();
				})
				.catch(() => { this._populateFakeAlerts(); });
		}
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			let hash = 'preview';
			try {
				const user = await this.$api.get('userData');
				hash = user?.widget_hash || 'preview';
			} catch(e) { /* ignore */ }
			if(!this.$refs.container) return;

			this.widget = new ScrollerWidget({ container: this.$refs.container });

			await this.widget.init({ settings: { ...(this.settings || {}) } });

			const baseCSSElem = document.getElementById('scBaseCSS');
			if(baseCSSElem) {
				baseCSSElem.textContent = baseCSSElem.textContent
					.replace(/(?:html|body)(?:\s*,\s*(?:html|body))?\s*\{[^}]*\}/g, '');
			}

			if(this.realData) {
				const itemCount = this.widget.settings.itemCount || 10;
				const donationsOnly = this.widget.settings.donationsOnly;
				let url = `widget/${encodeURIComponent(hash)}/alerts?limit=${itemCount}`;
				if(donationsOnly) url += '&donationsOnly=1';
				const alerts = await this.$api.get(url).catch(() => []);
				if(alerts?.length) this.widget.applyAlerts(alerts);

				this._previewSubId = this.$socket.subscribe(hash, {
					reconnect: () => this._destroyWidget() || this._initWidget(),
					userWidgetAlert: data => this.widget?._onAlert(data),
				});
			}
		},
		_destroyWidget() {
			if(this._previewSubId != null) { this.$socket.unsubscribe(this._previewSubId); this._previewSubId = null; }
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
		_populateFakeAlerts() {
			if(!this.widget) return;
			const count = this.settings.itemCount || 10;
			for(let i = 0; i < count; i++) {
				const username = USERNAMES[i % USERNAMES.length];
				const amount = Math.round((1 + Math.random() * 299) * 100) / 100;

				let serviceId = null, serviceName = null, serviceIconUrl = null;
				if(this.services.length > 0) {
					const svc = this.services[i % this.services.length];
					serviceId    = svc.service_id;
					serviceName  = svc.service_name || svc.service_id;
					serviceIconUrl = svc.service_icon_url;
				}

				this.widget._pushAlert({
					id: `preview-${++msgIdCounter}`,
					serviceId,
					serviceName,
					serviceIconUrl,
					type: 'gift',
					giftType: 'donation',
					value: amount,
					currency: 'USD',
					sender: { displayName: username, avatar: null },
					spans: [],
				});
			}
			this.widget._rebuildTrack();
		},
	},
};
</script>
